<template>
  <div class="interest-explorer global__fade-in-up" :id="id">
    <div class="interest-explorer__top">
      <slot name="top"></slot>
    </div>
    <div class="interest-explorer__content" ref="content">
      <div class="anchor" ref="anchor"></div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import jQuery from 'jquery'

export default {
  props: {
    id: {
      type: String,
      default: 'interest-explorer-1',
    },
  },
  mounted() {
    this.tabIndex = 0
    this.tablist = this.$el.querySelector('.interest-explorer__tabs')
    this.tabs = this.$el.querySelectorAll('.interest-explorer__tab')
    this.panels = this.$el.querySelectorAll('.interest-explorer__panel')
    this.activePanel = this.$refs.content.children[1]
    var that = this
    this.tabs.forEach(function(tab) {
      tab.addEventListener('click', function(event) {
        // let fade be instant on mobile since it needs to anchor to content
        var fadeSpeed = 400
        // deselect previous tab and hide its panel, select new tab and show its panel
        that.tablist
          .querySelector('[aria-selected="true"]')
          .setAttribute('aria-selected', false)
        event.target.setAttribute('aria-selected', true)
        // fade out old panel
        jQuery(that.activePanel).fadeOut(fadeSpeed)
        that.activePanel = document.getElementById(
          event.target.getAttribute('aria-controls')
        )
        // fade in new panel
        jQuery(that.activePanel).fadeIn(fadeSpeed)
        that.$refs.anchor.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        })
        document.cookie = 'selectedInterest=' + event.target.id
      })
      // add keyboard navigation
      tab.addEventListener('keydown', function(event) {
        // navigate tabs with left and right arrow keys
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          that.tabs[that.tabIndex].setAttribute('tabindex', -1)
          if (event.key === 'ArrowLeft') {
            if (--that.tabIndex < 0) {
              that.tabIndex = that.tabs.length - 1
            }
          } else if (event.key === 'ArrowRight') {
            if (++that.tabIndex >= that.tabs.length) {
              that.tabIndex = 0
            }
          }
          that.tabs[that.tabIndex].setAttribute('tabindex', 0)
          that.tabs[that.tabIndex].focus()
        }
      })
    })
    var cookies = decodeURIComponent(document.cookie)
      .split(';')
      .map(cookie => cookie.trim())
    var selectedInterest = cookies.find(
      cookie => cookie.indexOf('selectedInterest') > -1
    )
    var interestId = selectedInterest ? selectedInterest.split('=')[1] : null
    if (interestId) {
      document.getElementById(interestId).click()
    }
  },
}
</script>
